const IconButton = (props) => {
    const { children, position, onClick } = props;

    return (
        <div className={position == "start" ? "styledStartIcon" : "styledEndIcon"}>
            <button className="btn" onClick={onClick}>
                {children}
            </button>
        </div>
    );
}

export default IconButton;